import React, { useRef, useEffect, useState } from 'react';
import * as THREE from 'three';
import textureSrc from "../Assets/planets/aqua/temp/temp_1-5.png";
                        
import { useSelector, useDispatch } from "react-redux";
import { ACTIONS as DATA_ACTIONS } from "../redux/reducers/DataReducer"
import { get } from '../theme/theme';

import { HeightSlider } from "./twoD";

import aqua_wind from "../Assets/planets/legend/aqua_dz_dt-1.png"
import pcb_wind from "../Assets/planets/legend/pcb_dz_dt-2.png"
import aqua_temp from "../Assets/planets/legend/aqua_temp_1-18.png"
import pcb_temp from "../Assets/planets/legend/pcb_temp_1-16.png"

import aqua_temp_1_0 from "../Assets/planets/aqua/temp/temp_1-0.png";
import aqua_temp_1_1 from "../Assets/planets/aqua/temp/temp_1-1.png";
import aqua_temp_1_2 from "../Assets/planets/aqua/temp/temp_1-2.png";
import aqua_temp_1_3 from "../Assets/planets/aqua/temp/temp_1-3.png";
import aqua_temp_1_4 from "../Assets/planets/aqua/temp/temp_1-4.png";
import aqua_temp_1_5 from "../Assets/planets/aqua/temp/temp_1-5.png";
import aqua_temp_1_6 from "../Assets/planets/aqua/temp/temp_1-6.png";
import aqua_temp_1_7 from "../Assets/planets/aqua/temp/temp_1-7.png";
import aqua_temp_1_8 from "../Assets/planets/aqua/temp/temp_1-8.png";
import aqua_temp_1_9 from "../Assets/planets/aqua/temp/temp_1-9.png";
import aqua_temp_1_10 from "../Assets/planets/aqua/temp/temp_1-10.png";
import aqua_temp_1_11 from "../Assets/planets/aqua/temp/temp_1-11.png";
import aqua_temp_1_12 from "../Assets/planets/aqua/temp/temp_1-12.png";
import aqua_temp_1_13 from "../Assets/planets/aqua/temp/temp_1-13.png";
import aqua_temp_1_14 from "../Assets/planets/aqua/temp/temp_1-14.png";
import aqua_temp_1_15 from "../Assets/planets/aqua/temp/temp_1-15.png";
import aqua_temp_1_16 from "../Assets/planets/aqua/temp/temp_1-16.png";
import aqua_temp_1_17 from "../Assets/planets/aqua/temp/temp_1-17.png";
import aqua_temp_1_18 from "../Assets/planets/aqua/temp/temp_1-18.png";
import aqua_temp_1_19 from "../Assets/planets/aqua/temp/temp_1-19.png";
import aqua_temp_1_20 from "../Assets/planets/aqua/temp/temp_1-20.png";
import aqua_temp_1_21 from "../Assets/planets/aqua/temp/temp_1-21.png";
import aqua_temp_1_22 from "../Assets/planets/aqua/temp/temp_1-22.png";
import aqua_temp_1_23 from "../Assets/planets/aqua/temp/temp_1-23.png";
import aqua_temp_1_24 from "../Assets/planets/aqua/temp/temp_1-24.png";
import aqua_temp_1_25 from "../Assets/planets/aqua/temp/temp_1-25.png";
import aqua_temp_1_26 from "../Assets/planets/aqua/temp/temp_1-26.png";
import aqua_temp_1_27 from "../Assets/planets/aqua/temp/temp_1-27.png";
import aqua_temp_1_28 from "../Assets/planets/aqua/temp/temp_1-28.png";
import aqua_temp_1_29 from "../Assets/planets/aqua/temp/temp_1-29.png";
import aqua_temp_1_30 from "../Assets/planets/aqua/temp/temp_1-30.png";
import aqua_temp_1_31 from "../Assets/planets/aqua/temp/temp_1-31.png";
import aqua_temp_1_32 from "../Assets/planets/aqua/temp/temp_1-32.png";
import aqua_temp_1_33 from "../Assets/planets/aqua/temp/temp_1-33.png";
import aqua_temp_1_34 from "../Assets/planets/aqua/temp/temp_1-34.png";
import aqua_temp_1_35 from "../Assets/planets/aqua/temp/temp_1-35.png";
// import aqua_temp_1_36 from "../Assets/planets/aqua/temp/temp_1-36.png";
// import aqua_temp_1_37 from "../Assets/planets/aqua/temp/temp_1-37.png";
// import aqua_temp_1_38 from "../Assets/planets/aqua/temp/temp_1-38.png";
// import aqua_temp_1_39 from "../Assets/planets/aqua/temp/temp_1-39.png";
// import aqua_temp_1_40 from "../Assets/planets/aqua/temp/temp_1-40.png";
// import aqua_temp_1_41 from "../Assets/planets/aqua/temp/temp_1-41.png";
// import aqua_temp_1_42 from "../Assets/planets/aqua/temp/temp_1-42.png";
// import aqua_temp_1_43 from "../Assets/planets/aqua/temp/temp_1-43.png";
// import aqua_temp_1_44 from "../Assets/planets/aqua/temp/temp_1-44.png";
// import aqua_temp_1_45 from "../Assets/planets/aqua/temp/temp_1-45.png";
// import aqua_temp_1_46 from "../Assets/planets/aqua/temp/temp_1-46.png";
// import aqua_temp_1_47 from "../Assets/planets/aqua/temp/temp_1-47.png";
// import aqua_temp_1_48 from "../Assets/planets/aqua/temp/temp_1-48.png";
// import aqua_temp_1_49 from "../Assets/planets/aqua/temp/temp_1-49.png";
// import aqua_temp_1_50 from "../Assets/planets/aqua/temp/temp_1-50.png";
// import aqua_temp_1_51 from "../Assets/planets/aqua/temp/temp_1-51.png";
// import aqua_temp_1_52 from "../Assets/planets/aqua/temp/temp_1-52.png";
// import aqua_temp_1_53 from "../Assets/planets/aqua/temp/temp_1-53.png";
// import aqua_temp_1_54 from "../Assets/planets/aqua/temp/temp_1-54.png";
// import aqua_temp_1_55 from "../Assets/planets/aqua/temp/temp_1-55.png";
// import aqua_temp_1_56 from "../Assets/planets/aqua/temp/temp_1-56.png";
// import aqua_temp_1_57 from "../Assets/planets/aqua/temp/temp_1-57.png";
// import aqua_temp_1_58 from "../Assets/planets/aqua/temp/temp_1-58.png";
// import aqua_temp_1_59 from "../Assets/planets/aqua/temp/temp_1-59.png";

import aqua_dz_dt_0 from "../Assets/planets/aqua/wind/dz_dt-0.png";
import aqua_dz_dt_1 from "../Assets/planets/aqua/wind/dz_dt-1.png";
import aqua_dz_dt_2 from "../Assets/planets/aqua/wind/dz_dt-2.png";
import aqua_dz_dt_3 from "../Assets/planets/aqua/wind/dz_dt-3.png";
import aqua_dz_dt_4 from "../Assets/planets/aqua/wind/dz_dt-4.png";
import aqua_dz_dt_5 from "../Assets/planets/aqua/wind/dz_dt-5.png"; 
import aqua_dz_dt_6 from "../Assets/planets/aqua/wind/dz_dt-6.png";
import aqua_dz_dt_7 from "../Assets/planets/aqua/wind/dz_dt-7.png";
import aqua_dz_dt_8 from "../Assets/planets/aqua/wind/dz_dt-8.png";
import aqua_dz_dt_9 from "../Assets/planets/aqua/wind/dz_dt-9.png";
import aqua_dz_dt_10 from "../Assets/planets/aqua/wind/dz_dt-10.png";
import aqua_dz_dt_11 from "../Assets/planets/aqua/wind/dz_dt-11.png";
import aqua_dz_dt_12 from "../Assets/planets/aqua/wind/dz_dt-12.png";
import aqua_dz_dt_13 from "../Assets/planets/aqua/wind/dz_dt-13.png";
import aqua_dz_dt_14 from "../Assets/planets/aqua/wind/dz_dt-14.png";
import aqua_dz_dt_15 from "../Assets/planets/aqua/wind/dz_dt-15.png";
import aqua_dz_dt_16 from "../Assets/planets/aqua/wind/dz_dt-16.png";
import aqua_dz_dt_17 from "../Assets/planets/aqua/wind/dz_dt-17.png";
import aqua_dz_dt_18 from "../Assets/planets/aqua/wind/dz_dt-18.png";
import aqua_dz_dt_19 from "../Assets/planets/aqua/wind/dz_dt-19.png";
import aqua_dz_dt_20 from "../Assets/planets/aqua/wind/dz_dt-20.png";
import aqua_dz_dt_21 from "../Assets/planets/aqua/wind/dz_dt-21.png";
import aqua_dz_dt_22 from "../Assets/planets/aqua/wind/dz_dt-22.png";
import aqua_dz_dt_23 from "../Assets/planets/aqua/wind/dz_dt-23.png";
import aqua_dz_dt_24 from "../Assets/planets/aqua/wind/dz_dt-24.png";
import aqua_dz_dt_25 from "../Assets/planets/aqua/wind/dz_dt-25.png";
import aqua_dz_dt_26 from "../Assets/planets/aqua/wind/dz_dt-26.png";
import aqua_dz_dt_27 from "../Assets/planets/aqua/wind/dz_dt-27.png";
import aqua_dz_dt_28 from "../Assets/planets/aqua/wind/dz_dt-28.png";
import aqua_dz_dt_29 from "../Assets/planets/aqua/wind/dz_dt-29.png";
import aqua_dz_dt_30 from "../Assets/planets/aqua/wind/dz_dt-30.png";
import aqua_dz_dt_31 from "../Assets/planets/aqua/wind/dz_dt-31.png";
import aqua_dz_dt_32 from "../Assets/planets/aqua/wind/dz_dt-32.png";
import aqua_dz_dt_33 from "../Assets/planets/aqua/wind/dz_dt-33.png";
import aqua_dz_dt_34 from "../Assets/planets/aqua/wind/dz_dt-34.png";
import aqua_dz_dt_35 from "../Assets/planets/aqua/wind/dz_dt-35.png";
// import aqua_dz_dt_36 from "../Assets/planets/aqua/wind/dz_dt-36.png";
// import aqua_dz_dt_37 from "../Assets/planets/aqua/wind/dz_dt-37.png";
// import aqua_dz_dt_38 from "../Assets/planets/aqua/wind/dz_dt-38.png";
// import aqua_dz_dt_39 from "../Assets/planets/aqua/wind/dz_dt-39.png";
// import aqua_dz_dt_40 from "../Assets/planets/aqua/wind/dz_dt-40.png";
// import aqua_dz_dt_41 from "../Assets/planets/aqua/wind/dz_dt-41.png";
// import aqua_dz_dt_42 from "../Assets/planets/aqua/wind/dz_dt-42.png";
// import aqua_dz_dt_43 from "../Assets/planets/aqua/wind/dz_dt-43.png";
// import aqua_dz_dt_44 from "../Assets/planets/aqua/wind/dz_dt-44.png";
// import aqua_dz_dt_45 from "../Assets/planets/aqua/wind/dz_dt-45.png";
// import aqua_dz_dt_46 from "../Assets/planets/aqua/wind/dz_dt-46.png";
// import aqua_dz_dt_47 from "../Assets/planets/aqua/wind/dz_dt-47.png";
// import aqua_dz_dt_48 from "../Assets/planets/aqua/wind/dz_dt-48.png";
// import aqua_dz_dt_49 from "../Assets/planets/aqua/wind/dz_dt-49.png";
// import aqua_dz_dt_50 from "../Assets/planets/aqua/wind/dz_dt-50.png";
// import aqua_dz_dt_51 from "../Assets/planets/aqua/wind/dz_dt-51.png";
// import aqua_dz_dt_52 from "../Assets/planets/aqua/wind/dz_dt-52.png";
// import aqua_dz_dt_53 from "../Assets/planets/aqua/wind/dz_dt-53.png";
// import aqua_dz_dt_54 from "../Assets/planets/aqua/wind/dz_dt-54.png";
// import aqua_dz_dt_55 from "../Assets/planets/aqua/wind/dz_dt-55.png";
// import aqua_dz_dt_56 from "../Assets/planets/aqua/wind/dz_dt-56.png";
// import aqua_dz_dt_57 from "../Assets/planets/aqua/wind/dz_dt-57.png";
// import aqua_dz_dt_58 from "../Assets/planets/aqua/wind/dz_dt-58.png";
// import aqua_dz_dt_59 from "../Assets/planets/aqua/wind/dz_dt-59.png";

import pcb_temp_1_0 from "../Assets/planets/pcb/temp/temp_1-0.png";
import pcb_temp_1_1 from "../Assets/planets/pcb/temp/temp_1-1.png";
import pcb_temp_1_2 from "../Assets/planets/pcb/temp/temp_1-2.png";
import pcb_temp_1_3 from "../Assets/planets/pcb/temp/temp_1-3.png";
import pcb_temp_1_4 from "../Assets/planets/pcb/temp/temp_1-4.png";
import pcb_temp_1_5 from "../Assets/planets/pcb/temp/temp_1-5.png";
import pcb_temp_1_6 from "../Assets/planets/pcb/temp/temp_1-6.png";
import pcb_temp_1_7 from "../Assets/planets/pcb/temp/temp_1-7.png";
import pcb_temp_1_8 from "../Assets/planets/pcb/temp/temp_1-8.png";
import pcb_temp_1_9 from "../Assets/planets/pcb/temp/temp_1-9.png";
import pcb_temp_1_10 from "../Assets/planets/pcb/temp/temp_1-10.png";
import pcb_temp_1_11 from "../Assets/planets/pcb/temp/temp_1-11.png";
import pcb_temp_1_12 from "../Assets/planets/pcb/temp/temp_1-12.png";
import pcb_temp_1_13 from "../Assets/planets/pcb/temp/temp_1-13.png";
import pcb_temp_1_14 from "../Assets/planets/pcb/temp/temp_1-14.png";
import pcb_temp_1_15 from "../Assets/planets/pcb/temp/temp_1-15.png";
import pcb_temp_1_16 from "../Assets/planets/pcb/temp/temp_1-16.png";
import pcb_temp_1_17 from "../Assets/planets/pcb/temp/temp_1-17.png";
import pcb_temp_1_18 from "../Assets/planets/pcb/temp/temp_1-18.png";
import pcb_temp_1_19 from "../Assets/planets/pcb/temp/temp_1-19.png";
import pcb_temp_1_20 from "../Assets/planets/pcb/temp/temp_1-20.png";
import pcb_temp_1_21 from "../Assets/planets/pcb/temp/temp_1-21.png";
import pcb_temp_1_22 from "../Assets/planets/pcb/temp/temp_1-22.png";
import pcb_temp_1_23 from "../Assets/planets/pcb/temp/temp_1-23.png";
import pcb_temp_1_24 from "../Assets/planets/pcb/temp/temp_1-24.png";
import pcb_temp_1_25 from "../Assets/planets/pcb/temp/temp_1-25.png";
import pcb_temp_1_26 from "../Assets/planets/pcb/temp/temp_1-26.png";
import pcb_temp_1_27 from "../Assets/planets/pcb/temp/temp_1-27.png";
import pcb_temp_1_28 from "../Assets/planets/pcb/temp/temp_1-28.png";
import pcb_temp_1_29 from "../Assets/planets/pcb/temp/temp_1-29.png";
import pcb_temp_1_30 from "../Assets/planets/pcb/temp/temp_1-30.png";
import pcb_temp_1_31 from "../Assets/planets/pcb/temp/temp_1-31.png";
import pcb_temp_1_32 from "../Assets/planets/pcb/temp/temp_1-32.png";
import pcb_temp_1_33 from "../Assets/planets/pcb/temp/temp_1-33.png";
import pcb_temp_1_34 from "../Assets/planets/pcb/temp/temp_1-34.png";
import pcb_temp_1_35 from "../Assets/planets/pcb/temp/temp_1-35.png";
// import pcb_temp_1_36 from "../Assets/planets/pcb/temp/temp_1-36.png";
// import pcb_temp_1_37 from "../Assets/planets/pcb/temp/temp_1-37.png";
// import pcb_temp_1_38 from "../Assets/planets/pcb/temp/temp_1-38.png";
// import pcb_temp_1_39 from "../Assets/planets/pcb/temp/temp_1-39.png";
// import pcb_temp_1_40 from "../Assets/planets/pcb/temp/temp_1-40.png";
// import pcb_temp_1_41 from "../Assets/planets/pcb/temp/temp_1-41.png";
// import pcb_temp_1_42 from "../Assets/planets/pcb/temp/temp_1-42.png";
// import pcb_temp_1_43 from "../Assets/planets/pcb/temp/temp_1-43.png";
// import pcb_temp_1_44 from "../Assets/planets/pcb/temp/temp_1-44.png";
// import pcb_temp_1_45 from "../Assets/planets/pcb/temp/temp_1-45.png";
// import pcb_temp_1_46 from "../Assets/planets/pcb/temp/temp_1-46.png";
// import pcb_temp_1_47 from "../Assets/planets/pcb/temp/temp_1-47.png";
// import pcb_temp_1_48 from "../Assets/planets/pcb/temp/temp_1-48.png";
// import pcb_temp_1_49 from "../Assets/planets/pcb/temp/temp_1-49.png";
// import pcb_temp_1_50 from "../Assets/planets/pcb/temp/temp_1-50.png";
// import pcb_temp_1_51 from "../Assets/planets/pcb/temp/temp_1-51.png";
// import pcb_temp_1_52 from "../Assets/planets/pcb/temp/temp_1-52.png";
// import pcb_temp_1_53 from "../Assets/planets/pcb/temp/temp_1-53.png";
// import pcb_temp_1_54 from "../Assets/planets/pcb/temp/temp_1-54.png";
// import pcb_temp_1_55 from "../Assets/planets/pcb/temp/temp_1-55.png";
// import pcb_temp_1_56 from "../Assets/planets/pcb/temp/temp_1-56.png";
// import pcb_temp_1_57 from "../Assets/planets/pcb/temp/temp_1-57.png";
// import pcb_temp_1_58 from "../Assets/planets/pcb/temp/temp_1-58.png";
// import pcb_temp_1_59 from "../Assets/planets/pcb/temp/temp_1-59.png";



import pcb_dz_dt_0 from "../Assets/planets/pcb/wind/dz_dt-0.png";
import pcb_dz_dt_1 from "../Assets/planets/pcb/wind/dz_dt-1.png";
import pcb_dz_dt_2 from "../Assets/planets/pcb/wind/dz_dt-2.png";
import pcb_dz_dt_3 from "../Assets/planets/pcb/wind/dz_dt-3.png";
import pcb_dz_dt_4 from "../Assets/planets/pcb/wind/dz_dt-4.png";
import pcb_dz_dt_5 from "../Assets/planets/pcb/wind/dz_dt-5.png";
import pcb_dz_dt_6 from "../Assets/planets/pcb/wind/dz_dt-6.png";
import pcb_dz_dt_7 from "../Assets/planets/pcb/wind/dz_dt-7.png";
import pcb_dz_dt_8 from "../Assets/planets/pcb/wind/dz_dt-8.png";
import pcb_dz_dt_9 from "../Assets/planets/pcb/wind/dz_dt-9.png";
import pcb_dz_dt_10 from "../Assets/planets/pcb/wind/dz_dt-10.png";
import pcb_dz_dt_11 from "../Assets/planets/pcb/wind/dz_dt-11.png";
import pcb_dz_dt_12 from "../Assets/planets/pcb/wind/dz_dt-12.png";
import pcb_dz_dt_13 from "../Assets/planets/pcb/wind/dz_dt-13.png";
import pcb_dz_dt_14 from "../Assets/planets/pcb/wind/dz_dt-14.png";
import pcb_dz_dt_15 from "../Assets/planets/pcb/wind/dz_dt-15.png";
import pcb_dz_dt_16 from "../Assets/planets/pcb/wind/dz_dt-16.png";
import pcb_dz_dt_17 from "../Assets/planets/pcb/wind/dz_dt-17.png";
import pcb_dz_dt_18 from "../Assets/planets/pcb/wind/dz_dt-18.png";
import pcb_dz_dt_19 from "../Assets/planets/pcb/wind/dz_dt-19.png";
import pcb_dz_dt_20 from "../Assets/planets/pcb/wind/dz_dt-20.png";
import pcb_dz_dt_21 from "../Assets/planets/pcb/wind/dz_dt-21.png";
import pcb_dz_dt_22 from "../Assets/planets/pcb/wind/dz_dt-22.png";
import pcb_dz_dt_23 from "../Assets/planets/pcb/wind/dz_dt-23.png";
import pcb_dz_dt_24 from "../Assets/planets/pcb/wind/dz_dt-24.png";
import pcb_dz_dt_25 from "../Assets/planets/pcb/wind/dz_dt-25.png";
import pcb_dz_dt_26 from "../Assets/planets/pcb/wind/dz_dt-26.png";
import pcb_dz_dt_27 from "../Assets/planets/pcb/wind/dz_dt-27.png";
import pcb_dz_dt_28 from "../Assets/planets/pcb/wind/dz_dt-28.png";
import pcb_dz_dt_29 from "../Assets/planets/pcb/wind/dz_dt-29.png";
import pcb_dz_dt_30 from "../Assets/planets/pcb/wind/dz_dt-30.png";
import pcb_dz_dt_31 from "../Assets/planets/pcb/wind/dz_dt-31.png";
import pcb_dz_dt_32 from "../Assets/planets/pcb/wind/dz_dt-32.png";
import pcb_dz_dt_33 from "../Assets/planets/pcb/wind/dz_dt-33.png";
import pcb_dz_dt_34 from "../Assets/planets/pcb/wind/dz_dt-34.png";
import pcb_dz_dt_35 from "../Assets/planets/pcb/wind/dz_dt-35.png";
// import pcb_dz_dt_36 from "../Assets/planets/pcb/wind/dz_dt-36.png";
// import pcb_dz_dt_37 from "../Assets/planets/pcb/wind/dz_dt-37.png";
// import pcb_dz_dt_38 from "../Assets/planets/pcb/wind/dz_dt-38.png";
// import pcb_dz_dt_39 from "../Assets/planets/pcb/wind/dz_dt-39.png";
// import pcb_dz_dt_40 from "../Assets/planets/pcb/wind/dz_dt-40.png";
// import pcb_dz_dt_41 from "../Assets/planets/pcb/wind/dz_dt-41.png";
// import pcb_dz_dt_42 from "../Assets/planets/pcb/wind/dz_dt-42.png";
// import pcb_dz_dt_43 from "../Assets/planets/pcb/wind/dz_dt-43.png";
// import pcb_dz_dt_44 from "../Assets/planets/pcb/wind/dz_dt-44.png";
// import pcb_dz_dt_45 from "../Assets/planets/pcb/wind/dz_dt-45.png";
// import pcb_dz_dt_46 from "../Assets/planets/pcb/wind/dz_dt-46.png";
// import pcb_dz_dt_47 from "../Assets/planets/pcb/wind/dz_dt-47.png";
// import pcb_dz_dt_48 from "../Assets/planets/pcb/wind/dz_dt-48.png";
// import pcb_dz_dt_49 from "../Assets/planets/pcb/wind/dz_dt-49.png";
// import pcb_dz_dt_50 from "../Assets/planets/pcb/wind/dz_dt-50.png";
// import pcb_dz_dt_51 from "../Assets/planets/pcb/wind/dz_dt-51.png";
// import pcb_dz_dt_52 from "../Assets/planets/pcb/wind/dz_dt-52.png";
// import pcb_dz_dt_53 from "../Assets/planets/pcb/wind/dz_dt-53.png";
// import pcb_dz_dt_54 from "../Assets/planets/pcb/wind/dz_dt-54.png";
// import pcb_dz_dt_55 from "../Assets/planets/pcb/wind/dz_dt-55.png";
// import pcb_dz_dt_56 from "../Assets/planets/pcb/wind/dz_dt-56.png";
// import pcb_dz_dt_57 from "../Assets/planets/pcb/wind/dz_dt-57.png";
// import pcb_dz_dt_58 from "../Assets/planets/pcb/wind/dz_dt-58.png";
// import pcb_dz_dt_59 from "../Assets/planets/pcb/wind/dz_dt-59.png";


const CanvasTexture = ({ onTextureReady }) => {
    const canvasRef = useRef(null);
    const containerRef = useRef(null);
    const dispatch = useDispatch();
    const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });
    const [lastClickPos, setLastClickPos] = useState(null); // Store the last click position
    const data = useSelector(state => state.data);

    const planetdata = {};

    planetdata.aqua_temp_1_0 = aqua_temp_1_0;
    planetdata.aqua_temp_1_1 = aqua_temp_1_1;
    planetdata.aqua_temp_1_2 = aqua_temp_1_2;
    planetdata.aqua_temp_1_3 = aqua_temp_1_3;
    planetdata.aqua_temp_1_4 = aqua_temp_1_4;
    planetdata.aqua_temp_1_5 = aqua_temp_1_5;
    planetdata.aqua_temp_1_6 = aqua_temp_1_6;
    planetdata.aqua_temp_1_7 = aqua_temp_1_7;
    planetdata.aqua_temp_1_8 = aqua_temp_1_8;
    planetdata.aqua_temp_1_9 = aqua_temp_1_9;
    planetdata.aqua_temp_1_10 = aqua_temp_1_10;
    planetdata.aqua_temp_1_11 = aqua_temp_1_11;
    planetdata.aqua_temp_1_12 = aqua_temp_1_12;
    planetdata.aqua_temp_1_13 = aqua_temp_1_13;
    planetdata.aqua_temp_1_14 = aqua_temp_1_14;
    planetdata.aqua_temp_1_15 = aqua_temp_1_15;
    planetdata.aqua_temp_1_16 = aqua_temp_1_16;
    planetdata.aqua_temp_1_17 = aqua_temp_1_17;
    planetdata.aqua_temp_1_18 = aqua_temp_1_18;
    planetdata.aqua_temp_1_19 = aqua_temp_1_19;
    planetdata.aqua_temp_1_20 = aqua_temp_1_20;
    planetdata.aqua_temp_1_21 = aqua_temp_1_21;
    planetdata.aqua_temp_1_22 = aqua_temp_1_22;
    planetdata.aqua_temp_1_23 = aqua_temp_1_23;
    planetdata.aqua_temp_1_24 = aqua_temp_1_24;
    planetdata.aqua_temp_1_25 = aqua_temp_1_25;
    planetdata.aqua_temp_1_26 = aqua_temp_1_26;
    planetdata.aqua_temp_1_27 = aqua_temp_1_27;
    planetdata.aqua_temp_1_28 = aqua_temp_1_28;
    planetdata.aqua_temp_1_29 = aqua_temp_1_29;
    planetdata.aqua_temp_1_30 = aqua_temp_1_30;
    planetdata.aqua_temp_1_31 = aqua_temp_1_31;
    planetdata.aqua_temp_1_32 = aqua_temp_1_32;
    planetdata.aqua_temp_1_33 = aqua_temp_1_33;
    planetdata.aqua_temp_1_34 = aqua_temp_1_34;
    planetdata.aqua_temp_1_35 = aqua_temp_1_35;
    // planetdata.aqua_temp_1_36 = aqua_temp_1_36;
    // planetdata.aqua_temp_1_37 = aqua_temp_1_37;
    // planetdata.aqua_temp_1_38 = aqua_temp_1_38;
    // planetdata.aqua_temp_1_39 = aqua_temp_1_39;
    // planetdata.aqua_temp_1_40 = aqua_temp_1_40;
    // planetdata.aqua_temp_1_41 = aqua_temp_1_41;
    // planetdata.aqua_temp_1_42 = aqua_temp_1_42;
    // planetdata.aqua_temp_1_43 = aqua_temp_1_43;
    // planetdata.aqua_temp_1_44 = aqua_temp_1_44;
    // planetdata.aqua_temp_1_45 = aqua_temp_1_45;
    // planetdata.aqua_temp_1_46 = aqua_temp_1_46;
    // planetdata.aqua_temp_1_47 = aqua_temp_1_47;
    // planetdata.aqua_temp_1_48 = aqua_temp_1_48;
    // planetdata.aqua_temp_1_49 = aqua_temp_1_49;
    // planetdata.aqua_temp_1_50 = aqua_temp_1_50;
    // planetdata.aqua_temp_1_51 = aqua_temp_1_51;
    // planetdata.aqua_temp_1_52 = aqua_temp_1_52;
    // planetdata.aqua_temp_1_53 = aqua_temp_1_53;
    // planetdata.aqua_temp_1_54 = aqua_temp_1_54;
    // planetdata.aqua_temp_1_55 = aqua_temp_1_55;
    // planetdata.aqua_temp_1_56 = aqua_temp_1_56;
    // planetdata.aqua_temp_1_57 = aqua_temp_1_57;
    // planetdata.aqua_temp_1_58 = aqua_temp_1_58;
    // planetdata.aqua_temp_1_59 = aqua_temp_1_59;

    planetdata.aqua_dz_dt_0 = aqua_dz_dt_0;
    planetdata.aqua_dz_dt_1 = aqua_dz_dt_1;
    planetdata.aqua_dz_dt_2 = aqua_dz_dt_2;
    planetdata.aqua_dz_dt_3 = aqua_dz_dt_3;
    planetdata.aqua_dz_dt_4 = aqua_dz_dt_4;
    planetdata.aqua_dz_dt_5 = aqua_dz_dt_5;
    planetdata.aqua_dz_dt_6 = aqua_dz_dt_6;
    planetdata.aqua_dz_dt_7 = aqua_dz_dt_7;
    planetdata.aqua_dz_dt_8 = aqua_dz_dt_8;
    planetdata.aqua_dz_dt_9 = aqua_dz_dt_9;
    planetdata.aqua_dz_dt_10 = aqua_dz_dt_10;
    planetdata.aqua_dz_dt_11 = aqua_dz_dt_11;
    planetdata.aqua_dz_dt_12 = aqua_dz_dt_12;
    planetdata.aqua_dz_dt_13 = aqua_dz_dt_13;
    planetdata.aqua_dz_dt_14 = aqua_dz_dt_14;
    planetdata.aqua_dz_dt_15 = aqua_dz_dt_15;
    planetdata.aqua_dz_dt_16 = aqua_dz_dt_16;
    planetdata.aqua_dz_dt_17 = aqua_dz_dt_17;
    planetdata.aqua_dz_dt_18 = aqua_dz_dt_18;
    planetdata.aqua_dz_dt_19 = aqua_dz_dt_19;
    planetdata.aqua_dz_dt_20 = aqua_dz_dt_20;
    planetdata.aqua_dz_dt_21 = aqua_dz_dt_21;
    planetdata.aqua_dz_dt_22 = aqua_dz_dt_22;
    planetdata.aqua_dz_dt_23 = aqua_dz_dt_23;
    planetdata.aqua_dz_dt_24 = aqua_dz_dt_24;
    planetdata.aqua_dz_dt_25 = aqua_dz_dt_25;
    planetdata.aqua_dz_dt_26 = aqua_dz_dt_26;
    planetdata.aqua_dz_dt_27 = aqua_dz_dt_27;
    planetdata.aqua_dz_dt_28 = aqua_dz_dt_28;
    planetdata.aqua_dz_dt_29 = aqua_dz_dt_29;
    planetdata.aqua_dz_dt_30 = aqua_dz_dt_30;
    planetdata.aqua_dz_dt_31 = aqua_dz_dt_31;
    planetdata.aqua_dz_dt_32 = aqua_dz_dt_32;
    planetdata.aqua_dz_dt_33 = aqua_dz_dt_33;
    planetdata.aqua_dz_dt_34 = aqua_dz_dt_34;
    planetdata.aqua_dz_dt_35 = aqua_dz_dt_35;
    // planetdata.aqua_dz_dt_36 = aqua_dz_dt_36;
    // planetdata.aqua_dz_dt_37 = aqua_dz_dt_37;
    // planetdata.aqua_dz_dt_38 = aqua_dz_dt_38;
    // planetdata.aqua_dz_dt_39 = aqua_dz_dt_39;
    // planetdata.aqua_dz_dt_40 = aqua_dz_dt_40;
    // planetdata.aqua_dz_dt_41 = aqua_dz_dt_41;
    // planetdata.aqua_dz_dt_42 = aqua_dz_dt_42;
    // planetdata.aqua_dz_dt_43 = aqua_dz_dt_43;
    // planetdata.aqua_dz_dt_44 = aqua_dz_dt_44;
    // planetdata.aqua_dz_dt_45 = aqua_dz_dt_45;
    // planetdata.aqua_dz_dt_46 = aqua_dz_dt_46;
    // planetdata.aqua_dz_dt_47 = aqua_dz_dt_47;
    // planetdata.aqua_dz_dt_48 = aqua_dz_dt_48;
    // planetdata.aqua_dz_dt_49 = aqua_dz_dt_49;
    // planetdata.aqua_dz_dt_50 = aqua_dz_dt_50;
    // planetdata.aqua_dz_dt_51 = aqua_dz_dt_51;
    // planetdata.aqua_dz_dt_52 = aqua_dz_dt_52;
    // planetdata.aqua_dz_dt_53 = aqua_dz_dt_53;
    // planetdata.aqua_dz_dt_54 = aqua_dz_dt_54;
    // planetdata.aqua_dz_dt_55 = aqua_dz_dt_55;
    // planetdata.aqua_dz_dt_56 = aqua_dz_dt_56;
    // planetdata.aqua_dz_dt_57 = aqua_dz_dt_57;
    // planetdata.aqua_dz_dt_58 = aqua_dz_dt_58;
    // planetdata.aqua_dz_dt_59 = aqua_dz_dt_59;
    

    
    planetdata.pcb_temp_1_0 = pcb_temp_1_0;
    planetdata.pcb_temp_1_1 = pcb_temp_1_1;
    planetdata.pcb_temp_1_2 = pcb_temp_1_2;
    planetdata.pcb_temp_1_3 = pcb_temp_1_3;
    planetdata.pcb_temp_1_4 = pcb_temp_1_4;
    planetdata.pcb_temp_1_5 = pcb_temp_1_5;
    planetdata.pcb_temp_1_6 = pcb_temp_1_6;
    planetdata.pcb_temp_1_7 = pcb_temp_1_7;
    planetdata.pcb_temp_1_8 = pcb_temp_1_8;
    planetdata.pcb_temp_1_9 = pcb_temp_1_9;
    planetdata.pcb_temp_1_10 = pcb_temp_1_10;
    planetdata.pcb_temp_1_11 = pcb_temp_1_11;
    planetdata.pcb_temp_1_12 = pcb_temp_1_12;
    planetdata.pcb_temp_1_13 = pcb_temp_1_13;
    planetdata.pcb_temp_1_14 = pcb_temp_1_14;
    planetdata.pcb_temp_1_15 = pcb_temp_1_15;
    planetdata.pcb_temp_1_16 = pcb_temp_1_16;
    planetdata.pcb_temp_1_17 = pcb_temp_1_17;
    planetdata.pcb_temp_1_18 = pcb_temp_1_18;
    planetdata.pcb_temp_1_19 = pcb_temp_1_19;
    planetdata.pcb_temp_1_20 = pcb_temp_1_20;
    planetdata.pcb_temp_1_21 = pcb_temp_1_21;
    planetdata.pcb_temp_1_22 = pcb_temp_1_22;
    planetdata.pcb_temp_1_23 = pcb_temp_1_23;
    planetdata.pcb_temp_1_24 = pcb_temp_1_24;
    planetdata.pcb_temp_1_25 = pcb_temp_1_25;
    planetdata.pcb_temp_1_26 = pcb_temp_1_26;
    planetdata.pcb_temp_1_27 = pcb_temp_1_27;
    planetdata.pcb_temp_1_28 = pcb_temp_1_28;
    planetdata.pcb_temp_1_29 = pcb_temp_1_29;
    planetdata.pcb_temp_1_30 = pcb_temp_1_30;
    planetdata.pcb_temp_1_31 = pcb_temp_1_31;
    planetdata.pcb_temp_1_32 = pcb_temp_1_32;
    planetdata.pcb_temp_1_33 = pcb_temp_1_33;
    planetdata.pcb_temp_1_34 = pcb_temp_1_34;
    planetdata.pcb_temp_1_35 = pcb_temp_1_35;
    // planetdata.pcb_temp_1_36 = pcb_temp_1_36;
    // planetdata.pcb_temp_1_37 = pcb_temp_1_37;
    // planetdata.pcb_temp_1_38 = pcb_temp_1_38;
    // planetdata.pcb_temp_1_39 = pcb_temp_1_39;
    // planetdata.pcb_temp_1_40 = pcb_temp_1_40;
    // planetdata.pcb_temp_1_41 = pcb_temp_1_41;
    // planetdata.pcb_temp_1_42 = pcb_temp_1_42;
    // planetdata.pcb_temp_1_43 = pcb_temp_1_43;
    // planetdata.pcb_temp_1_44 = pcb_temp_1_44;
    // planetdata.pcb_temp_1_45 = pcb_temp_1_45;
    // planetdata.pcb_temp_1_46 = pcb_temp_1_46;
    // planetdata.pcb_temp_1_47 = pcb_temp_1_47;
    // planetdata.pcb_temp_1_48 = pcb_temp_1_48;
    // planetdata.pcb_temp_1_49 = pcb_temp_1_49;
    // planetdata.pcb_temp_1_50 = pcb_temp_1_50;
    // planetdata.pcb_temp_1_51 = pcb_temp_1_51;
    // planetdata.pcb_temp_1_52 = pcb_temp_1_52;
    // planetdata.pcb_temp_1_53 = pcb_temp_1_53;
    // planetdata.pcb_temp_1_54 = pcb_temp_1_54;
    // planetdata.pcb_temp_1_55 = pcb_temp_1_55;
    // planetdata.pcb_temp_1_56 = pcb_temp_1_56;
    // planetdata.pcb_temp_1_57 = pcb_temp_1_57;
    // planetdata.pcb_temp_1_58 = pcb_temp_1_58;
    // planetdata.pcb_temp_1_59 = pcb_temp_1_59;

    planetdata.pcb_dz_dt_0 = pcb_dz_dt_0;
    planetdata.pcb_dz_dt_1 = pcb_dz_dt_1;
    planetdata.pcb_dz_dt_2 = pcb_dz_dt_2;
    planetdata.pcb_dz_dt_3 = pcb_dz_dt_3;
    planetdata.pcb_dz_dt_4 = pcb_dz_dt_4;
    planetdata.pcb_dz_dt_5 = pcb_dz_dt_5;
    planetdata.pcb_dz_dt_6 = pcb_dz_dt_6;
    planetdata.pcb_dz_dt_7 = pcb_dz_dt_7;
    planetdata.pcb_dz_dt_8 = pcb_dz_dt_8;
    planetdata.pcb_dz_dt_9 = pcb_dz_dt_9;
    planetdata.pcb_dz_dt_10 = pcb_dz_dt_10;
    planetdata.pcb_dz_dt_11 = pcb_dz_dt_11;
    planetdata.pcb_dz_dt_12 = pcb_dz_dt_12;
    planetdata.pcb_dz_dt_13 = pcb_dz_dt_13;
    planetdata.pcb_dz_dt_14 = pcb_dz_dt_14;
    planetdata.pcb_dz_dt_15 = pcb_dz_dt_15;
    planetdata.pcb_dz_dt_16 = pcb_dz_dt_16;
    planetdata.pcb_dz_dt_17 = pcb_dz_dt_17;
    planetdata.pcb_dz_dt_18 = pcb_dz_dt_18;
    planetdata.pcb_dz_dt_19 = pcb_dz_dt_19;
    planetdata.pcb_dz_dt_20 = pcb_dz_dt_20;
    planetdata.pcb_dz_dt_21 = pcb_dz_dt_21;
    planetdata.pcb_dz_dt_22 = pcb_dz_dt_22;
    planetdata.pcb_dz_dt_23 = pcb_dz_dt_23;
    planetdata.pcb_dz_dt_24 = pcb_dz_dt_24;
    planetdata.pcb_dz_dt_25 = pcb_dz_dt_25;
    planetdata.pcb_dz_dt_26 = pcb_dz_dt_26;
    planetdata.pcb_dz_dt_27 = pcb_dz_dt_27;
    planetdata.pcb_dz_dt_28 = pcb_dz_dt_28;
    planetdata.pcb_dz_dt_29 = pcb_dz_dt_29;
    planetdata.pcb_dz_dt_30 = pcb_dz_dt_30;
    planetdata.pcb_dz_dt_31 = pcb_dz_dt_31;
    planetdata.pcb_dz_dt_32 = pcb_dz_dt_32;
    planetdata.pcb_dz_dt_33 = pcb_dz_dt_33;
    planetdata.pcb_dz_dt_34 = pcb_dz_dt_34;
    planetdata.pcb_dz_dt_35 = pcb_dz_dt_35;
    // planetdata.pcb_dz_dt_36 = pcb_dz_dt_36;
    // planetdata.pcb_dz_dt_37 = pcb_dz_dt_37;
    // planetdata.pcb_dz_dt_38 = pcb_dz_dt_38;
    // planetdata.pcb_dz_dt_39 = pcb_dz_dt_39;
    // planetdata.pcb_dz_dt_40 = pcb_dz_dt_40;
    // planetdata.pcb_dz_dt_41 = pcb_dz_dt_41;
    // planetdata.pcb_dz_dt_42 = pcb_dz_dt_42;
    // planetdata.pcb_dz_dt_43 = pcb_dz_dt_43;
    // planetdata.pcb_dz_dt_44 = pcb_dz_dt_44;
    // planetdata.pcb_dz_dt_45 = pcb_dz_dt_45;
    // planetdata.pcb_dz_dt_46 = pcb_dz_dt_46;
    // planetdata.pcb_dz_dt_47 = pcb_dz_dt_47;
    // planetdata.pcb_dz_dt_48 = pcb_dz_dt_48;
    // planetdata.pcb_dz_dt_49 = pcb_dz_dt_49;
    // planetdata.pcb_dz_dt_50 = pcb_dz_dt_50;
    // planetdata.pcb_dz_dt_51 = pcb_dz_dt_51;
    // planetdata.pcb_dz_dt_52 = pcb_dz_dt_52;
    // planetdata.pcb_dz_dt_53 = pcb_dz_dt_53;
    // planetdata.pcb_dz_dt_54 = pcb_dz_dt_54;
    // planetdata.pcb_dz_dt_55 = pcb_dz_dt_55;
    // planetdata.pcb_dz_dt_56 = pcb_dz_dt_56;
    // planetdata.pcb_dz_dt_57 = pcb_dz_dt_57;
    // planetdata.pcb_dz_dt_58 = pcb_dz_dt_58;
    // planetdata.pcb_dz_dt_59 = pcb_dz_dt_59;
    


    const getTexture =  ()=>{
        const planet = data.planet;
        const variable = data.variable;
        const height = data.height;

    
        let planets, variables, heights, name;

        if (planet == "PCB"){
            planets = "pcb";
        } else {
            planets = "aqua";
        }

        if (variable == "temperature"){
            variables = "temp"
            heights = Math.floor(height/100*36)
            name = "temp_1"
        } else {
            variables = "wind"
            name = "dz_dt"
            heights = Math.floor(height/100*36)
        }

        return planetdata[`${planets}_${name}_${heights}`]
        
        return `${name}${height}`

        return textureSrc;
    }
  

    useEffect(() => {
        const container = containerRef.current;
        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                setContainerSize({
                    width: entry.contentRect.width,
                    height: entry.contentRect.height
                });
            }
        });
        if (container) {
            resizeObserver.observe(container);
        }

        return () => {
            if (container) {
                resizeObserver.unobserve(container);
                // clearInterval(poiChecker);
            }
        };
    }, []);

    useEffect(() => {
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');

        const img = new Image();
        img.src = getTexture();

        img.onload = function() {
            const aspectRatio = img.naturalWidth / img.naturalHeight;
            const canvasHeight = containerSize.width / aspectRatio;

            canvas.width = containerSize.width;
            canvas.height = canvasHeight;

            context.drawImage(img, 0, 0, canvas.width, canvas.height);

            // If there is a last click position, draw a circle at that position
            if (lastClickPos) {
                const x = lastClickPos.x * canvas.width;
                const y = lastClickPos.y * canvas.height;
                context.fillStyle = 'red';
                context.beginPath();
                context.arc(x, y, 5, 0, Math.PI * 2); // Draw circle with radius 10
                context.fill();
            }

            if (data.poi && data.poi.length){
              data.poi.forEach(poi => {
                context.fillStyle = poi.color;
                context.beginPath();
                context.arc(poi.coordinates.x * canvas.width, poi.coordinates.y * canvas.height, 5, 0, Math.PI * 2); // Draw circle with radius 10
                context.fill();
              });
            }

            const texture = new THREE.CanvasTexture(canvas);
            onTextureReady(texture);
        };
        
        
    
            
        

    }, [containerSize, onTextureReady, lastClickPos, data]);

    console.log(data)

    // Handle click events on the canvas
    const handleCanvasClick = (event) => {
        const rect = event.target.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width).toFixed(3); // Normalize x coordinate
        const y = ((event.clientY - rect.top) / rect.height).toFixed(3); // Normalize y coordinate
        dispatch({type: DATA_ACTIONS.SET_COORDINATES, coordinates: {x, y}})
        setLastClickPos({ x, y }); // Update the last click position
    };

    return <div ref={containerRef} style={{ width: '100%', height: '100%' }}>
        <canvas ref={canvasRef} onClick={handleCanvasClick} />
        <img src={(()=>{
            if (data.planet == "Aqua"){
                if (data.variable == "temperature"){
                    return aqua_temp;    
                } else {
                    return aqua_wind;
                }
            }    else {
                if (data.variable == "temperature"){
                    return pcb_temp;    
                } else {
                    return pcb_wind;
                }
            } 
    })()} style={{
         width: "100%",
         
        }} />
        <HeightSlider />
        
    </div>;
};

export default CanvasTexture;
